export const PageText = {
  _1: 'Help & Guides',
  _2: 'Something not clear? Check our help section...'
};

export const Categories = {
  _1: {
    title: 'Get started',
    idSelector: '#get-started',
    subcategories: [
      {
        key: 0,
        text: 'Here you will find all info and guides you need to get started with aircheckr:'
      }
    ],
    links: [
      {
        text: 'How to get an aircheckr access token/key?',
        linkAddress: '/help-and-guides/how-to-get-an-aircheckr-access-token'
      },
      {
        text: 'First steps with the aircheckr API and widget',
        linkAddress: '/help-and-guides/first-steps-with-the-aircheckr-api'
      },
      {
        text: 'Get in touch',
        linkAddress: '/contact'
      }
    ]
  },
  _2: {
    title: 'Importance of air quality (monitoring)',
    idSelector: '#importance-of-air-quality',
    subcategories: [
      {
        key: 0,
        text: 'This is a great starting point to learn more about air quality and its effects:'
      }
    ],
    links: [
      {
        text: 'What is air pollution?',
        linkAddress: '/help-and-guides/what-is-air-pollution'
      },
      {
        text: 'The silent killer',
        linkAddress: '/help-and-guides/the-silent-killer'
      },
      {
        text: 'Air pollution & the curse of the 3C’s',
        linkAddress: '/help-and-guides/air-pollution-and-the-curse'
      },
      {
        text: 'Do my customers really want air quality info? ',
        linkAddress: '/help-and-guides/do-my-customers-really-want-air-quality-info'
      },
      {
        text: 'There is hope!',
        linkAddress: '/help-and-guides/there-is-hope'
      },
      {
        text: 'Personalised recommendations (& alerts)',
        linkAddress: '/help-and-guides/personalised-recommendations'
      },
    ]
  },
   _3: {
    title: 'Aircheckr data API',
    idSelector: '#aircheckr-data-api',
    subcategories: [
      {
        key: 0,
        text: 'Here you will find all the information necessary to integrate aircheckr-data into your application:'
      }
    ],
    links: [
      {
        text: 'Aircheckr API documentation',
        externalLinkAddress: '/api_docs'
      }
    ]
  },
  _5: {
    title: 'aircheckr legal',
    idSelector: '#aircheckr-legal',
    subcategories: [
      {
        key: 0,
        text: 'All legal documents related to our services and website can be found here:'
      }
    ],
    links: [
      {
        text: 'Terms of Use',
        externalLinkAddress: 'https://legal.nazka.be/docs/en/terms-of-use/',
        target: '_blank'
      },
      {
        text: 'Cookie policy',
        externalLinkAddress: 'https://legal.nazka.be/docs/en/cookie-policy/',
        target: '_blank'
      },
      {
        text: 'Privacy policy',
        externalLinkAddress: 'https://legal.nazka.be/docs/en/privacy-policy/',
        target: '_blank'
      },
      {
        text: 'Saas Agreement Free Plan',
        externalLinkAddress: 'https://legal.nazka.be/docs/en/nazka-aircheckr-SaaS-free-plan_17042018_web.pdf',
        target: '_blank'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/helpandguides_page.js